import { render, staticRenderFns } from "./perasaan-pengetahuan.vue?vue&type=template&id=61e41849&scoped=true&"
import script from "./perasaan-pengetahuan.vue?vue&type=script&lang=js&"
export * from "./perasaan-pengetahuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e41849",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CText: require('@chakra-ui/vue').CText, CBox: require('@chakra-ui/vue').CBox})
